

















import { Vue, Component, Mixins } from "vue-property-decorator";

import SelectStadium from "@/components/selectstadium.vue";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart,
    SelectStadium
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  option: any = {
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c}单 ({d}%)"
    },
    legend: {
      orient: "vertical",
      x: "left",
      data: []
    },
    series: [
      {
        type: "pie",
        radius: "55%",
        center: ["50%", "60%"],
        label: {
          // normal: {
            // position: 'inner',
            formatter: "{b} \n {c}单（{d}%）"
          // }
        },
        data: []
      }
    ]
  };

  ei: any = {};

  // echartsTheme: {} = tdTheme;

  async loadData() {
    const res2 = await this.$store.dispatch("statistics/getBillSettleType", {});
    if (res2 && res2.Data) {
      this.option.series[0].data = [];
      this.option.legend.data = [];

      this.option.series[0].data = res2.Data;

      for (const obj of res2.Data) {
        this.option.legend.data.push(obj.name);
      }
      // console.log(this.option)
    }
  }

  mounted() {
    this.loadData();
  }
}
